import React, {Component, Fragment} from 'react';
import NumericLabel from 'react-pretty-numbers';
import moment from 'moment';
import { intervalList, displayDateFormat, imgStoragePath } from  '../../../../constants';
import { showCurrencyFormat } from  '../../../../utils';
import { checkPermission } from  '../../../../utils_v2';
import { ContrListCol } from '../../Elements';
import { jetStreamInstance } from '../../../../lease_management/Leases';
export default class LeaseRentalList extends Component{
 constructor(props){
  super(props);
 }
 render(){
  const { rental, index, params } = this.props;
  const rentalObj = [
    { value: rental.rental_type && rental.rental_type.label ? rental.rental_type.label : '--' },
    { value: rental.account_type && rental.account_type.label ? rental.account_type.label : '--' },
    {
      value: rental.rental_rate_name ? (
        <>
          {rental.rental_rate_name}
          <span style={{ fontSize: '11px', fontFamily: "Conv_IBMPlexSans-SemiBold", display: 'block' }}>Invoice Type: <p style={{ fontSize: '12px', fontFamily: "Conv_IBMPlexSans",textTransform:'uppercase' }}>{rental.rental_invoice_type?.label ?? '--'}</p></span>
          <span style={{ fontSize: '11px', fontFamily: "Conv_IBMPlexSans-SemiBold", display: 'block' }}>Asset: <p style={{ fontSize: '12px', fontFamily: "Conv_IBMPlexSans" }}>{rental.asset.name ?? '--'}</p></span>
        </>
      ) : (
        '--'
      )
    },
    { value: rental.currency  ? rental.currency : '--' },
    { value: rental.rental_type && (rental.rental_type.value === 3 || rental.rental_type.value === 4 || rental.rental_type.value === 5)&& rental.unit_of_measure && rental.unit_of_measure.label ? rental.unit_of_measure.label : rental.interval && rental.interval.label ? rental.interval.label  : '--' },
    { value:  rental?.rental_type?.value == 3? <span style={{textDecoration:'underline', color:'blue'}}>View Rate </span> : rental.amount?<NumericLabel params={showCurrencyFormat(rental.currency)}>{rental.amount}</NumericLabel>:'--'},
    { value: rental.escalation_percentage  && rental.escalation_percentage ?  rental.escalation_percentage + '%': '--' },
    { value: rental.start_date ? moment(rental.start_date).format(displayDateFormat):'--'  },
    { value: rental.end_date ? moment(rental.end_date).format(displayDateFormat):'--' },
    { value:  <span>{checkPermission('contracts', 'lease_rental_rate', 'D') && index != 0 ?<p className="delete" onClick={(e) => this.props.deleteFn(e, rental.id)}>Delete</p>:null}
     <p  style={{fontSize:'10px',color:'#2F8CFE'}}>{rental.requested_data && Object.keys(rental.requested_data).length ? '( Pending Review )':''}</p>
    </span>
    } 
  ];
  const filteredRentalObj = rentalObj.filter((col, idx) => {
    if ((idx === 1||idx === 2) && !jetStreamInstance) { 
      return false;
    }
    return true;
  });

  return (
    <tr onClick={() => this.props.viewRental(params, rental.id, 'view')}>
      {filteredRentalObj.map((rental, index) => <ContrListCol colObj={rental} key={index} />)}
    </tr>
  );
 }
}
